import React, { Component } from 'react';
import AboutSidebar from '../components/basic/AboutSidebar';
import EducatorResource from '../components/basic/EducatorResource';
import IntroWithButton from '../components/global/IntroWithButton';
import RectButton from '../components/ui/RectButton';

import introStyle from '../components/global/IntroWithButton.module.scss';

import styles from './basic.module.scss';
import { Lazy } from 'react-lazy';
import Observer from 'react-intersection-observer';
import Helmet from 'react-helmet';

class BasicPage extends Component {
  state = {
    topImageLoaded: false,
    bottomImageLoaded: false,
    revealText: false,
    topImageInView: false,
    bottomImageInView: false,
  };
  title = this.props.data.dataJson.title
    .replace('<strong>', '')
    .replace('</strong>', '');
  handleTopImageLoaded = () => {
    this.setState(
      {
        topImageLoaded: true,
      },
      this.handleTopImageInView
    );
  };
  handleBottomImageLoaded = () => {
    this.setState(
      {
        bottomImageLoaded: true,
      },
      this.handleBottomImageInView
    );
  };

  handleTopImageInView = () => {
    this.state.topImageLoaded &&
      this.setState({
        topImageInView: true,
      });
  };

  handleBottomImageInView = () => {
    this.state.bottomImageLoaded &&
      this.setState({
        bottomImageInView: true,
      });
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({ revealText: true });
    }, 300);
    this.props.resetDisplaySettings();
    this.props.setHeaderTransparent(false);
    // this.props.setHeaderSticky(true);
    // this.props.setHeaderStatic(false);
    this.props.setThemeColor('red');
  }

  componentWillUnmount() {
    this.props.setHeaderTransparent(true);
    // this.props.setHeaderSticky(false);
    // this.props.setHeaderStatic(true);
  }
  isPage(pageString) {
    return this.props.location.pathname.indexOf(pageString) !== -1;
  }

  render() {
    const {
      title,
      color_theme,
      subtitle,
      body,
      second_body,
      headline,
      second_headline,
      top_image,
      bottom_image,
      page_content,
      is_about_page,
      second_cta,
    } = this.props.data.dataJson;

    return (
      <div
        className={`${styles.basicPage} ${
          this.props.transition && this.props.transition.status === 'exiting'
            ? styles.exiting
            : ''
        }`}
      >
        <Helmet title={`${this.title} | The House on Henry Street`} />
        <div className={styles.topWrapper}>
          <div className={styles.introWrapper}>
            <div
              className={`${styles.textEnter} ${
                !this.props.introIsShowing && this.state.revealText
                  ? styles.textEnterShow
                  : ''
              }`}
            >
              <div className={`${introStyle.maskWrap} ${introStyle.ruleMask}`}>
                <span
                  style={{ transformOrigin: '0 50%' }}
                  className={`ch-inner-rule ${introStyle.innerRule}`}
                />
              </div>
              <div className={introStyle.titleWrapper}>
                <h1
                  style={{
                    borderTop: '5px solid #D6434F',
                    paddingTop: '20px',
                    marginBottom: '10px',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: !is_about_page ? title : headline,
                  }}
                />
              </div>
              <div dangerouslySetInnerHTML={{ __html: body }} />
            </div>

            {is_about_page && (
              <AboutSidebar
                settingsContent={this.props.settingsContent}
                show={this.state.revealText && !this.props.introIsShowing}
              />
            )}
          </div>
          {top_image && (
            <Lazy
              onLoad={this.handleTopImageLoaded}
              onViewport={this.handleTopImageInView}
              className={`${styles.imageTop} ${
                this.state.topImageLoaded &&
                this.state.topImageInView &&
                !this.props.introIsShowing
                  ? styles.loaded
                  : ''
              }`}
            >
              <img src={top_image.url} alt={top_image.alt} />
            </Lazy>
          )}
        </div>
        {is_about_page && (
          <div className={styles.bottomWrapper}>
            <Lazy
              onLoad={this.handleBottomImageLoaded}
              onViewport={this.handleBottomImageInView}
              className={`${styles.imageBottom} ${
                this.state.bottomImageLoaded &&
                this.state.bottomImageInView &&
                !this.props.introIsShowing
                  ? styles.loaded
                  : ''
              }`}
            >
              <img src={bottom_image.url} alt={bottom_image.alt} />
            </Lazy>
            <Observer
              onChange={this.handleBottomInview}
              className={styles.introWrapperBottom}
              triggerOnce={true}
            >
              <div
                className={`${styles.textEnter} ${
                  !this.props.introIsShowing && this.state.revealText
                    ? styles.textEnterShow
                    : ''
                }`}
              >
                <div
                  className={`${introStyle.maskWrap} ${introStyle.ruleMask}`}
                >
                  <span
                    style={{ transformOrigin: '0 50%' }}
                    className={`ch-inner-rule ${introStyle.innerRule}`}
                  />
                </div>
                <div className={introStyle.titleWrapper}>
                  <h1
                    style={{
                      borderTop: '5px solid #D6434F',
                      paddingTop: '20px',
                      marginBottom: '10px',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: second_headline,
                    }}
                  />
                </div>
                <div dangerouslySetInnerHTML={{ __html: second_body }} />
              </div>

              {second_cta.url && (
                <RectButton
                  path={second_cta.url}
                  buttonText={second_cta.label ? second_cta.label : 'Explore'}
                />
              )}
            </Observer>
          </div>
        )}
        {this.isPage('educator') && page_content[0].resources[0].title && (
          <div className={`content-start ${styles.educatorResourcesGrid}`}>
            {page_content[0].resources.map((resource, index) => (
              <EducatorResource
                key={`${resource.title}-${index}`}
                {...resource}
              />
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default BasicPage;

export const exhibitionQuery = graphql`
  query BasicPageQuery($path: String!) {
    dataJson(path: { eq: $path }) {
      title
      is_about_page
      color_theme
      headline
      body
      subtitle
      second_headline
      second_body
      second_cta {
        url
        label
      }
      cta {
        url
        label
      }
      top_image {
        url
        alt
      }
      bottom_image {
        url
        alt
      }
      page_content {
        content_type
        resources {
          title
          body
          file {
            filename
            url
            size
          }
          image {
            url
            alt
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/basic.js